import { ClickCoveoEventType } from './clickCoveoEventType';
import { CoveoEventType } from './coveoEventType';
import {
    CaseStudyCoveoEventType,
    CustomizationGuideCoveoEventType,
    DataSheetCoveoEventType,
    ListingTabSwitchCoveoEventType,
    ScreenshotCoveoEventType,
    TestimonialCoveoEventType,
    TileClickCoveoEventType,
    TileViewCoveoEventType,
    WebinarCoveoEventType,
    WhitePaperCoveoEventType,
} from './customCoveoEventType';
import { PageViewCoveoEventType } from './pageViewCoveoEventType';
import { SearchCoveoEventType } from './searchCoveoEventType';

export class CoveoEventTypeFactory {
    static coveoEvents: CoveoEventType[] = [
        new PageViewCoveoEventType(),
        new ClickCoveoEventType(),
        new SearchCoveoEventType(),
        new TileViewCoveoEventType(),
        new TileClickCoveoEventType(),
        new ScreenshotCoveoEventType(),
        new ListingTabSwitchCoveoEventType(),
        new CaseStudyCoveoEventType(),
        new CustomizationGuideCoveoEventType(),
        new DataSheetCoveoEventType(),
        new WebinarCoveoEventType(),
        new TestimonialCoveoEventType(),
        new WhitePaperCoveoEventType(),
    ];

    // @ts-expect-error * Automated Type Error Fix
    static getEventType(event): CoveoEventType {
        // @ts-expect-error * Automated Type Error Fix
        return this.coveoEvents.find((eventType) => eventType.canHandle(event));
    }
}
